export interface PandianItem {
  id: string;
  tag: string;
  tone: string;
  title: string;
  lead: string;
  points: string[];
  count: string;
  span: string;
  icon: string;
  related: { slug: string; title: string }[];
}

export const pandianList: PandianItem[] = [
  {
    id: "taxing-zhonglei",
    tag: "塌房现场",
    tone: "bg-accent-100 text-accent-700",
    title: "塌房五大类型全图谱：一夜翻车有哪几种姿势？",
    lead: "把近年高热度塌房事件按成因归类，发现“人设不符、行为越线、旧账翻出、资本反噬、低情商发言”几乎能覆盖九成剧情。",
    points: [
      "人设不符型：表面谦逊私下反差，是最常见的翻车导火索",
      "行为越线型：一旦触碰红线，几乎立刻进入商业解约流程",
      "旧账翻出型：删除永远比考古慢一步",
      "资本反噬型：公司与艺人利益撕裂时最先爆雷",
      "低情商发言型：一句无心之言被语境放大成“塌房”",
    ],
    count: "覆盖 23 起典型事件",
    span: "近三年样本",
    icon: "ri-collapse-diagonal-line",
    related: [
      { slug: "taxi-yiye", title: "塌房一夜：从顶流到退圈的完整时间线" },
      { slug: "juyue-fengbo", title: "顶流解约风波" },
    ],
  },
  {
    id: "shengming-moban",
    tag: "声明对照",
    tone: "bg-secondary-100 text-secondary-800",
    title: "道歉声明话术库：明星道歉为什么总“一个模板”？",
    lead: "收集近年上百份公开声明，总结出“事实陈述—责任承担—致歉—后续措施”四段式模板，以及“避重就轻”与“诚恳认错”的措辞温差。",
    points: [
      "高频词：辜负、反思、深感歉意、将全面配合",
      "诚意信号：主动承认具体事实，而非仅说“造成困扰”",
      "避雷信号：出现“网传”“如果”“清者自清”多半在甩锅",
      "黄金时效：实锤后 24 小时内回应 vs 拖到通报后再回应",
    ],
    count: "样本 100+ 份公开声明",
    span: "持续更新中",
    icon: "ri-quill-pen-line",
    related: [
      { slug: "juyue-fengbo", title: "解约风波中的声明博弈" },
      { slug: "kaogu-heilishi", title: "被考古黑历史的公关回应" },
    ],
  },
  {
    id: "jiachang-honghei",
    tag: "假唱红黑",
    tone: "bg-primary-100 text-primary-700",
    title: "演唱会假唱争议红黑榜：真唱、垫音与假唱怎么分？",
    lead: "从“半开麦”“垫音”“对口型”等技术概念切入，盘点近年舞台争议事件，帮你把每一次“翻车”看懂门道。",
    points: [
      "真开麦：人声为主要声源，风险与实力并存",
      "半开麦/垫音：混入录音，音质稳但容易翻车被听出",
      "对口型假唱：多数是商演硬性要求，被扒后难洗",
      "判定依据：现场收音、波形对比、口型与走位误差",
    ],
    count: "收录 15 起舞台争议",
    span: "近四年事件",
    icon: "ri-mic-2-line",
    related: [
      { slug: "zongyi-juben", title: "综艺舞台真实性之争" },
    ],
  },
  {
    id: "hunyuan-jianji",
    tag: "综艺幕后",
    tone: "bg-secondary-100 text-secondary-800",
    title: "恶意剪辑争议大盘点：综艺的“剪刀手”在想什么？",
    lead: "盘点多档综艺被质疑“恶意剪辑”的经典名场面，拆解剪辑如何通过时间线重排、上下文截断改变人物形象。",
    points: [
      "错位拼接：把不同时点的反应剪成“同一场景”",
      "字幕引导：用一句带节奏的字幕放大表情",
      "保剧本戏：为冲突高潮保留“设计感”镜头",
      "选手下场：当事人吐槽常成为争议引爆点",
    ],
    count: "覆盖 9 档热门综艺",
    span: "跨多年案例",
    icon: "ri-film-line",
    related: [
      { slug: "zongyi-juben", title: "综艺“剧本”争议罗生门" },
    ],
  },
  {
    id: "fq-dazhan",
    tag: "粉圈大战",
    tone: "bg-accent-100 text-accent-700",
    title: "年度粉圈大战事件簿：番位、应援与反黑",
    lead: "把粉丝群体之间的大规模冲突按“导火索—动员—对线—平息”梳理，看清粉圈大战的运作逻辑与商业推手。",
    points: [
      "番位之争：海报排位、戏份占比都是开战理由",
      "应援跑路：集资与后援会账目是信任崩塌点",
      "反黑互撕：控评与举报常把冲突从圈内烧到圈外",
      "平台推手：热搜机制与话题运营助燃战火",
    ],
    count: "盘点 18 场大型battle",
    span: "年度滚动更新",
    icon: "ri-team-line",
    related: [
      { slug: "juyue-fengbo", title: "解约风波中的粉丝声援" },
    ],
  },
  {
    id: "gongguan-huashu",
    tag: "公关对照",
    tone: "bg-primary-100 text-primary-700",
    title: "经纪公司回应话术对照表：9 种句式翻译",
    lead: "把经纪公司惯用的“甩锅式”“冷处理式”“诚恳式”回应逐句翻译，教你在声明里读出真话与空话。",
    points: [
      "“网传内容不实”→ 只否认细节，未必否认事实",
      "“保留追究权利”→ 威慑造谣，也常是拖延",
      "“对占用公共资源深表歉意”→ 默认你已被实锤一半",
      "“请给予艺人空间”→ 往往意味着再无正面回应",
    ],
    count: "拆解 40+ 段真实话术",
    span: "持续更新",
    icon: "ri-chat-smile-3-line",
    related: [
      { slug: "shengming-moban", title: "道歉声明话术库" },
      { slug: "juyue-fengbo", title: "解约声明逐句拆" },
    ],
  },
];